import { makeStyles } from '@material-ui/core/styles';

export const useHistoryChatsStyles = makeStyles(theme => ({
  listSection: {
    flex: 1,
    overflowY: 'auto',
    marginTop: theme.spacing(1)
  }
}));
